// src/pages/invoice_terms/FacturenOpenstaandProjecten.js
import React, {useState, useMemo, useContext} from "react";
import { useInvoiceProjectData } from "../../../hooks/useInvoiceProjectData";
import InvoiceTable from "../../components/invoice_terms/InvoiceTable";
import { columnsDetailed } from "../../components/invoice_terms/columns";
import { useAuth0 } from "@auth0/auth0-react";
import PermissionsContext from "../../../utils/context";

const InvoiceDetailPage = () => {
    const { projects, loading, onFilterChange } = useInvoiceProjectData(1000);

    const { user } = useAuth0();
    const {permissions} = useContext(PermissionsContext);

    // Determine if user is admin
    const isAdmin = permissions.includes("admin:admin");

    const userWithAdminStatus = { ...user, isAdmin };

    const projectLeaders = [
        { id: "", label: "Iedereen" },
        { id: "Dick Bor", label: "Dick Bor" },
        { id: "Felicia Brosens", label: "Felicia Brosens" },
        { id: "John de Kroon", label: "John de Kroon" },
        { id: "Martijn Heerings", label: "Martijn Heerings" },
        { id: "Niels Leijen", label: "Niels Leijen" },
        { id: "Wilco Versteeg", label: "Wilco Versteeg" },
        { id: "Piet van de Zanden", label: "Piet van de Zanden" },
        { id: "Mark van der Steen", label: "Mark van der Steen" },
    ];

    const [selectedLeader, setSelectedLeader] = useState("");

    const handleLeaderChange = (e) => {
        const leader = e.target.value;
        setSelectedLeader(leader);
        onFilterChange("Projectleider", leader);
    };

    // Calculate the total amount for all filtered invoices
    const totalAmount = useMemo(() => {
        return projects.reduce((total, project) => {
            const amount = project.original?.invoice?.projects_invoice_terms_invoice_amount || 0;
            return total + parseFloat(amount);
        }, 0).toFixed(2);
    }, [projects]);

    if (loading) return <div>Loading...</div>;

    return (
        <>
            <div style={{ marginBottom: "1em" }}>
                <select
                    id="projectLeader"
                    value={selectedLeader}
                    onChange={handleLeaderChange}
                    style={{ marginLeft: "0.5em", padding: "0.5em" }}
                >
                    {projectLeaders.map((leader) => (
                        <option key={leader.id} value={leader.id}>
                            {leader.label}
                        </option>
                    ))}
                </select>
            </div>

            <InvoiceTable
                title="Openstaande facturen"
                columns={columnsDetailed}
                data={projects}
                onFilterValueChange={onFilterChange}
                defaultLimit={100}
                totaalOpenstaand={totalAmount}
                user={userWithAdminStatus}
            />
        </>
    );
};

export default InvoiceDetailPage;
